// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const stunky: PokeData = {
  "id": 434,
  "name": "stunky",
  "height": 4,
  "weight": 192,
  "base_experience": 66,
  "types": [
    PokeType.POISON,
    PokeType.DARK
  ],
  "api_moves": [
    "scratch",
    "tackle",
    "double-edge",
    "bite",
    "toxic",
    "screech",
    "smokescreen",
    "focus-energy",
    "poison-gas",
    "explosion",
    "fury-swipes",
    "slash",
    "memento",
    "feint",
    "sucker-punch",
    "poison-jab",
    "night-slash",
    "venoshock",
    "acid-spray",
    "belch",
    "venom-drench"
  ],
  "moves": [
    "scratch",
    "tackle",
    "bite",
    "poison-gas",
    "poison-jab",
    "night-slash",
    "venom-drench",
    "crunch",
    "night-daze",
    "mortal-gas",
    "phantom-force",
    "poison-powder",
    "pursuit"
  ],
  "evolution_chain": {
    "id": 223,
    "item": null,
    "species": [
      {
        "name": "stunky",
        "order": 458,
        "types": [
          PokeType.POISON,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "skuntank",
        "order": 459,
        "types": [
          PokeType.POISON,
          PokeType.DARK
        ],
        "evolves_from_species_id": 434,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 53.5,
    "speed": 74,
    "ability_power": 63
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
